import React from "react";
import {
  ArrowUpRight,
  ArrowDownLeft,
  CheckCircle2,
  XCircle,
  Clock,
  DollarSign,
} from "lucide-react";
import dayjs from "dayjs";
import "dayjs/locale/ar";

dayjs.locale("ar");

const TransactionCard = ({ transaction }) => {
  const isDeposit = transaction.trnsaction_type === "deposit";
  const statusConfig = {
    paid: {
      icon: CheckCircle2,
      color: "text-green-400",
      bg: "bg-green-500/10",
      border: "border-green-500/30",
      label: "مكتمل",
    },
    failed: {
      icon: XCircle,
      color: "text-red-400",
      bg: "bg-red-500/10",
      border: "border-red-500/30",
      label: "فشل",
    },
    pending: {
      icon: Clock,
      color: "text-yellow-400",
      bg: "bg-yellow-500/10",
      border: "border-yellow-500/30",
      label: "معلق",
    },
  };

  const currentStatus = statusConfig[transaction.status] || statusConfig.pending;
  const StatusIcon = currentStatus.icon;

  return (
    <div
      className={`bg-gray-800/50 rounded-xl p-4 border ${currentStatus.border} hover:bg-gray-800/70 transition-all duration-200`}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div
            className={`p-2 rounded-lg ${
              isDeposit ? "bg-green-500/10" : "bg-red-500/10"
            }`}
          >
            {isDeposit ? (
              <ArrowDownLeft className="w-5 h-5 text-green-400" />
            ) : (
              <ArrowUpRight className="w-5 h-5 text-red-400" />
            )}
          </div>
          <div>
            <h4 className="text-white font-medium">
              {transaction.payment_method_name}
            </h4>
            <p className="text-xs text-gray-400">
              {transaction.transaction_id}
            </p>
          </div>
        </div>

        <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${currentStatus.bg} border ${currentStatus.border}`}>
          <StatusIcon className={`w-4 h-4 ${currentStatus.color}`} />
          <span className={`text-sm font-medium ${currentStatus.color}`}>
            {currentStatus.label}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <DollarSign className="w-4 h-4 text-gray-400" />
          <span className="text-2xl font-bold text-white">
            {parseFloat(transaction.amount).toFixed(2)}
          </span>
          {transaction.commission > 0 && (
            <span className="text-xs text-gray-400">
              (عمولة: ${transaction.commission})
            </span>
          )}
        </div>

        <div className="text-left">
          <p className="text-xs text-gray-400">
            {dayjs(transaction.created_at).format("DD/MM/YYYY")}
          </p>
          <p className="text-xs text-gray-500">
            {dayjs(transaction.created_at).format("h:mm A")}
          </p>
        </div>
      </div>

      {transaction.transaction_details && (
        <div className="mt-3 pt-3 border-t border-gray-700/50">
          <p className="text-sm text-gray-400">{transaction.transaction_details}</p>
        </div>
      )}
    </div>
  );
};

export default TransactionCard;